export const cmps = {
    TIPO_DOC: 'tipoDoc',
    SERIE_DOC: 'serieDoc',
    NRO_DOC: 'nroDoc',
    PRODUCTO: 'producto',
    VERSION: 'version',
    PRESENTACION:'presentacion',
    MODULAR: 'modular',
    ANIO: 'anio',
    FECHA_EXPIRACION: 'fechaExpiracion',
    FECHA_VIGENCIA_API: 'fechaVigenciaApi',
    FECHA_VIGENCIA_SOPORTE: 'fechaVigenciaSoporte',
}